<script>
import TaxReturnRevenueSection from '@/components/accountants/tax_return/sections/TaxReturnRevenueSection.vue'
import Expandable from '@/components/Expandable.vue'
import TaxReturnCostsSection from '@/components/accountants/tax_return/sections/TaxReturnCostsSection.vue'
import TaxReturnEmployeeSection from '@/components/accountants/tax_return/sections/TaxReturnEmployeeSection.vue'
import TaxReturnDeductionsSection from '@/components/accountants/tax_return/sections/TaxReturnDeductionsSection.vue'
import TaxReturnWorthChangeSection from '@/components/accountants/tax_return/sections/TaxReturnWorthChangeSection.vue'
import TaxReturnActiveImmaterialSection from '@/components/accountants/tax_return/sections/TaxReturnActiveImmaterialSection.vue'
import TaxReturnMaterialActiveSection from '@/components/accountants/tax_return/sections/TaxReturnMaterialActiveSection.vue'
import TaxReturnFinancialActiveSection from '@/components/accountants/tax_return/sections/TaxReturnFinancialActiveSection.vue'
import TaxReturnSupplySection from '@/components/accountants/tax_return/sections/TaxReturnSupplySection.vue'
import TaxReturnAdvancementsSection from '@/components/accountants/tax_return/sections/TaxReturnAdvancementsSection.vue'
import TaxReturnEffectsSection from '@/components/accountants/tax_return/sections/TaxReturnEffectsSection.vue'
import TaxReturnLiquiditySection from '@/components/accountants/tax_return/sections/TaxReturnLiquiditySection.vue'
import TaxReturnPowerSection from '@/components/accountants/tax_return/sections/TaxReturnPowerSection.vue'
import TaxReturnReturnReserveSection from '@/components/accountants/tax_return/sections/TaxReturnReturnReserveSection.vue'
import TaxReturnWarrantySection from '@/components/accountants/tax_return/sections/TaxReturnWarrantySection.vue'
import TaxReturnLongTermDebtSection from '@/components/accountants/tax_return/sections/TaxReturnLongTermDebtSection.vue'
import TaxReturnShortTermDebtSection from '@/components/accountants/tax_return/sections/TaxReturnShortTermDebtSection.vue'
import TaxReturnReservesReductionSection from '@/components/accountants/tax_return/sections/TaxReturnReservesReductionSection.vue'
import TaxReturnDeductiblesSection from '@/components/accountants/tax_return/sections/TaxReturnDeductiblesSection.vue'
import TaxReturnReservesAdditionSection from '@/components/accountants/tax_return/sections/TaxReturnReservesAdditionSection.vue'
import TaxReturnOtherCompanyCostsSection from '@/components/accountants/tax_return/sections/TaxReturnOtherCompanyCostsSection.vue'
import GekkoButton from '@/components/GekkoButton.vue'
import TaxReturnTable from '@/components/accountants/tax_return/table/TaxReturnTable.vue'
import TaxReturnTableHeader from '@/components/accountants/tax_return/table/TaxReturnTableHeader.vue'
import TaxReturnTableRow from '@/components/accountants/tax_return/table/TaxReturnTableRow.vue'
import TaxReturnTableInput from '@/components/accountants/tax_return/table/TaxReturnTableInput.vue'
import TaxReturnSelfEmploymentSection from '@/components/accountants/tax_return/sections/TaxReturnSelfEmploymentSection.vue'
import TaxReturnStarterDeductionSection from '@/components/accountants/tax_return/sections/TaxReturnStarterDeductionSection.vue'

export default {
  name: 'TaxReturnSections',
  components: {
    TaxReturnStarterDeductionSection,
    TaxReturnSelfEmploymentSection,
    TaxReturnTableInput,
    TaxReturnTableRow,
    TaxReturnTableHeader,
    TaxReturnTable,
    GekkoButton,
    TaxReturnOtherCompanyCostsSection,
    TaxReturnReservesAdditionSection,
    TaxReturnDeductiblesSection,
    TaxReturnReservesReductionSection,
    TaxReturnShortTermDebtSection,
    TaxReturnLongTermDebtSection,
    TaxReturnWarrantySection,
    TaxReturnReturnReserveSection,
    TaxReturnPowerSection,
    TaxReturnLiquiditySection,
    TaxReturnEffectsSection,
    TaxReturnAdvancementsSection,
    TaxReturnSupplySection,
    TaxReturnFinancialActiveSection,
    TaxReturnMaterialActiveSection,
    TaxReturnActiveImmaterialSection,
    TaxReturnWorthChangeSection,
    TaxReturnDeductionsSection,
    TaxReturnEmployeeSection,
    TaxReturnCostsSection,
    Expandable,
    TaxReturnRevenueSection,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    addSmallScaleDeduction() {
      this.data.small_scale_deductions = [
        ...this.data.small_scale_deductions,
        {
          tax_return: this.data.id,
          description: `Aftrek #${this.data.small_scale_deductions.length + 1}`,
          invested_this_year: true,
          deduction_previous_year: '0.00',
          started_use_this_year: true,
          investment_amount_this_year: '0.00',
          investment_amount: '0.00',
        },
      ]
    },
    addEnergyAndClimateInvestment() {
      this.data.energy_and_climate_investments = [
        ...this.data.energy_and_climate_investments,
        {
          tax_return: this.data.id,
          description: `Investering #${this.data.energy_and_climate_investments.length + 1}`,
          type: 'climate',
          deduction_remainder_previous_years: '0.00',
          invested_this_year: true,
          start_of_use_date: `${this.data.year}-01-01`,
          amount: '0.00',
          deductible_amount: '0.00',
          case_number: 'M123456789',
          letter: 'A',
        },
      ]
    },
  },
  computed: {
    sumBalanceActive() {
      const props = [
        'balance_active_immaterial_goodwill',
        'balance_active_immaterial_other',
        'balance_active_material_real_estate_remaining',
        'balance_active_material_installations_remaining',
        'balance_active_material_materials_remaining',
        'balance_active_financial_financials',
        'balance_active_stock_stock',
        'balance_active_stock_work',
        'balance_active_claim_bruto',
        'balance_active_claim_debit',
        'balance_active_claim_other',
        'balance_active_effects_effects',
        'balance_active_liquid_liquid',
      ]

      return props.reduce((value, prop) => value + parseFloat(this.data.edit[prop] || 0), 0)
    },
    sumBalancePassive() {
      const props = [
        'balance_passive_business_assets_equity',
        'balance_passive_business_assets_equalisation_reserve',
        'balance_passive_business_assets_reinvest_reserve',
        'balance_passive_business_assets_old_age_reserve',
        'balance_passive_return_reserve',
        'balance_passive_warranty_provision',
        'balance_passive_warranty_other',
        'balance_passive_long_term_debt_credit',
        'balance_passive_long_term_debt_other',
        'balance_passive_short_term_debt_providers',
        'balance_passive_short_term_debt_salary',
        'balance_passive_short_term_debt_profit_tax',
        'balance_passive_short_term_debt_other',
        'balance_passive_short_term_debt_this_year',
        'balance_passive_short_term_debt_previous_year',
        'balance_passive_short_term_debt_older_years',
      ]

      return props.reduce((value, prop) => value + parseFloat(this.data.edit[prop] || 0), 0)
    },
  },
}
</script>

<template>
  <div class="tax-return-sections-container">
    <div class="balance-total">
      <div class="balance-total-items">
        <div class="balance-total-item">
          <translate class="balance-total-item-header">Totale activa</translate>
          <span class="balance-total-item-number">€{{ sumBalanceActive | formatNumber }}</span>
        </div>

        <div class="balance-total-item">
          <translate class="balance-total-item-header">Totale passiva</translate>
          <span class="balance-total-item-number">€{{ sumBalancePassive | formatNumber }}</span>
        </div>
      </div>

      <translate v-if="sumBalanceActive !== sumBalancePassive" class="balance-total-error">
        De totale activa is niet gelijk aan de totale passiva.
      </translate>
    </div>

    <div>
      <Expandable :title="$gettext('Winst-en-verliesrekening')">
        <Expandable :title="$gettext('Opbrengsten')">
          <TaxReturnRevenueSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Inkoopkosten, uitbesteed werk en andere externe kosten')">
          <TaxReturnCostsSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Personeelskosten')">
          <TaxReturnEmployeeSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Afschrijvingen')">
          <TaxReturnDeductionsSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Waardeverandering')">
          <TaxReturnWorthChangeSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Overige bedrijfskosten')">
          <TaxReturnOtherCompanyCostsSection :data="data" />
        </Expandable>
      </Expandable>

      <Expandable :title="$gettext('Balans: activa')">
        <Expandable :title="$gettext('Immateriele vaste activa')">
          <TaxReturnActiveImmaterialSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Materiele vaste activa')">
          <TaxReturnMaterialActiveSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Financiele vaste activa')">
          <TaxReturnFinancialActiveSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Voorraden')">
          <TaxReturnSupplySection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Vorderingen')">
          <TaxReturnAdvancementsSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Effecten')">
          <TaxReturnEffectsSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Liquide middelen')">
          <TaxReturnLiquiditySection :data="data" />
        </Expandable>
      </Expandable>

      <Expandable :title="$gettext('Balans: passiva')" is-main-box-or-something-i-dont-know>
        <Expandable :title="$gettext('Ondernemingsvermogen')">
          <TaxReturnPowerSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Terugkeerreserve')">
          <TaxReturnReturnReserveSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Voorzieningen')">
          <TaxReturnWarrantySection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Langlopende schulden')">
          <TaxReturnLongTermDebtSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Kortlopende schulden')">
          <TaxReturnShortTermDebtSection :data="data" />
        </Expandable>
      </Expandable>

      <Expandable :title="$gettext('Private deductions and deposits')">
        <Expandable :title="$gettext('Priveonttrekkingen in geld')">
          <TaxReturnDeductiblesSection :data="data" />
        </Expandable>
      </Expandable>

      <Expandable :title="$gettext('Wijzigingen in toelaatbare reserves')">
        <Expandable :title="$gettext('Afnames')">
          <TaxReturnReservesReductionSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Toevoegingen')">
          <TaxReturnReservesAdditionSection :data="data" />
        </Expandable>
      </Expandable>

      <Expandable :title="$gettext('Ondernemingsaftrek')">
        <Expandable :title="$gettext('Zelfstandigenaftrek')">
          <TaxReturnSelfEmploymentSection :data="data" />
        </Expandable>

        <Expandable :title="$gettext('Startersaftrek bij arbeidsongeschiktheid')">
          <TaxReturnStarterDeductionSection :data="data" />
        </Expandable>
      </Expandable>

      <Expandable :title="$gettext('Kleinschaligheidsaftrekkingen')">
        <Expandable
          v-for="(deduction, index) in data.small_scale_deductions"
          :title="deduction.description"
          :key="'small_scale_deductions-' + index"
        >
          <TaxReturnTable>
            <template v-slot:header>
              <tr>
                <th>
                  <translate>Beschrijving</translate>
                </th>

                <th>
                  <translate>Waarde</translate>
                </th>
              </tr>
            </template>

            <template v-slot:body>
              <tr>
                <td>
                  <translate>Omschrijving investering bedrijfsmiddel</translate>
                </td>

                <td>
                  <TaxReturnTableInput v-model="deduction.description" :resettable="false" />
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Uw restant investeringsaftrek van vorige boekjaren</translate>
                </td>

                <td>
                  <TaxReturnTableInput v-model="deduction.deduction_previous_year" :resettable="false" />
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Is de investering in het boekjaar in gebruik genomen?</translate>
                </td>

                <td>
                  <input v-model="deduction.started_use_this_year" type="checkbox" />
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Door u betaald bedrag in dit boekjaar voor deze investering</translate>
                </td>

                <td>
                  <TaxReturnTableInput v-model="deduction.investment_amount_this_year" :resettable="false" />
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Investeringsbedrag</translate>
                </td>

                <td>
                  <TaxReturnTableInput v-model="deduction.investment_amount" :resettable="false" />
                </td>
              </tr>
            </template>
          </TaxReturnTable>

          <button
            class="delete"
            @click.prevent="
              () => (data.small_scale_deductions = [...data.small_scale_deductions.filter((i) => deduction !== i)])
            "
          >
            <font-awesome-icon icon="fa-solid fa-trash" />
            <translate>Delete</translate>
          </button>
        </Expandable>

        <button class="new" @click.prevent="addSmallScaleDeduction">
          <font-awesome-icon icon="fa-solid fa-plus" />
          <translate>Voeg aftrek toe</translate>
        </button>
      </Expandable>

      <Expandable :title="$gettext('Energie- en milieu-investeringen')">
        <Expandable
          v-for="(investment, index) in data.energy_and_climate_investments"
          :title="investment.description"
          :key="'energy_and_climate_investments-' + index"
        >
          <TaxReturnTable>
            <template v-slot:header>
              <tr>
                <th>
                  <translate>Beschrijving</translate>
                </th>

                <th>
                  <translate>Waarde</translate>
                </th>
              </tr>
            </template>

            <template v-slot:body>
              <tr>
                <td>
                  <translate>Omschrijving investering bedrijfsmiddel</translate>
                </td>

                <td>
                  <TaxReturnTableInput v-model="investment.description" :resettable="false" />
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Soort investering</translate>
                </td>

                <td>
                  <b-dropdown>
                    <template #button-content>
                      <translate v-if="investment.type === 'climate'"> Milieu </translate>

                      <translate v-else-if="investment.type === 'energy'"> Energie </translate>
                    </template>

                    <b-dropdown-item @click="() => (investment.type = 'climate')">
                      <translate>Milieu</translate>
                    </b-dropdown-item>

                    <b-dropdown-item @click="() => (investment.type = 'energy')"> Energie </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Uw restant investeringsaftrek van vorige boekjaren</translate>
                </td>

                <td>
                  <TaxReturnTableInput v-model="investment.deduction_remainder_previous_years" :resettable="false" />
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Was de investering in dit boekjaar?</translate>
                </td>

                <td>
                  <input v-model="investment.invested_this_year" type="checkbox" />
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Datum waarop de investering in gebruik is genomen</translate>
                </td>

                <td>
                  <input v-model="investment.start_of_use_date" type="date" />
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Totaal investeringsbedrag</translate>
                </td>

                <td>
                  <TaxReturnTableInput v-model="investment.amount" :resettable="false" />
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Bedrag dat volgens RVO in aanmerking komt voor investeringsaftrek</translate>
                </td>

                <td>
                  <TaxReturnTableInput v-model="investment.deductible_amount" :resettable="false" />
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Meldingsnummer</translate>
                </td>

                <td>
                  <TaxReturnTableInput v-model="investment.case_number" :resettable="false" />
                </td>
              </tr>

              <tr>
                <td>
                  <translate>Eerste letter bedrijfsmiddelcode</translate>
                </td>

                <td>
                  <TaxReturnTableInput v-model="investment.letter" :resettable="false" />
                </td>
              </tr>
            </template>
          </TaxReturnTable>

          <button
            class="delete"
            @click.prevent="
              () =>
                (data.energy_and_climate_investments = [
                  ...data.energy_and_climate_investments.filter((i) => investment !== i),
                ])
            "
          >
            <font-awesome-icon icon="fa-solid fa-trash" />
            <translate>Delete</translate>
          </button>
        </Expandable>

        <button class="new" @click.prevent="addEnergyAndClimateInvestment">
          <font-awesome-icon icon="fa-solid fa-plus" />
          <translate>Voeg investering toe</translate>
        </button>
      </Expandable>
    </div>
  </div>
</template>

<style scoped lang="scss">
.balance-total {
  display: flex;
  position: fixed;
  bottom: 1rem;
  z-index: 100;
  flex-direction: column;
  margin: 0 0 1rem 0;
  padding: 1rem;
  box-shadow: 5px 5px 10px grey;
  border-radius: 0.5rem;
  gap: 0.3rem;
  background-color: white;
  border: 1px solid #209f80;

  &-items {
    display: flex;
    gap: 1rem;
  }

  &-item {
    display: flex;
    flex-direction: column;

    &-number {
      font-size: 24px;
    }

    &-header {
      font-size: 16px;
      font-family: DINNextLTPro-Regular, sans-serif;
    }
  }

  &-error {
    color: red;
    font-weight: bold;
  }
}

.tax-return-sections-container {
  padding: 16px;
}

button.new {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  color: white;
  background-color: #47d750;
  border-radius: 0.5rem;
  transition: all ease 0.2s;
  padding: 0.5rem;
  font-size: 18px;
  align-content: center;
  justify-content: center;
  outline: none;
  border: none;

  svg {
    position: relative;
    bottom: -5px;
  }

  &:hover {
    background-color: #2da534;
  }
}

button.delete {
  display: flex;
  flex-direction: row;
  background-color: #e84f4f;
  color: white;
  outline: none;
  border: none;
  padding: 0.5rem;
  font-size: 18px;
  transition: all ease 0.2s;
  align-content: center;
  justify-content: center;
  border-radius: 0.5rem;
  gap: 0.5rem;

  svg {
    position: relative;
    bottom: -5px;
  }

  &:hover {
    background-color: #bc3030;
  }
}
</style>